const PIXEL_ID = '1894598721199176'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

function loadMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  const run = () => loadMetaPixel()
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(run, { timeout: 2000 })
  } else {
    setTimeout(run, 200)
  }
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', params ?? {})
}

export const CART_URL =
  'https://06bqnm-1g.myshopify.com/cart/add?id=52066427338983&quantity=1'
